import * as API from "@utils/apiPath";
import { baseApi } from "./baseApi";

export interface DashboardMetric {
  title: string;
  value: string;
  change: number;
  changeType: "up" | "down";
  key: string;
}

export interface DashboardMetricsResponse {
  statusCode: number;
  message: string;
  data: {
    tab: string;
    timePeriod: string;
    metrics: DashboardMetric[];
  };
}

export interface DashboardChartsResponse {
  statusCode: number;
  message: string;
  data: {
    tab: string;
    timePeriod: string;
    revenueByRegion: {
      series: number[];
      labels: string[];
      totalAmount?: number;
      range: { start: string; end: string };
      /** Same order as `series` / `labels` — zone + status for that slice */
      segments: { zoneId: string; bookingStatus: string }[];
    };
    rideVsTime: {
      rides: {
        number: string;
        distance: string;
        duration: string;
        distanceKm: number;
        durationMin: number;
        createdAt: string;
      }[];
    };
    bookingConversion: {
      series: { name: string; data: number[] }[];
      categories: string[];
    };
    paymentMethodSplit: { series: number[]; labels: string[] };
    emergencyAlerts: {
      id: string;
      userType: "Customer" | "Driver" | "Unknown";
      userName: string;
      contactNo: string;
      safetyType: string;
      status: string;
      message: string;
      createdAt: string;
    }[];
  };
}

export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardMetrics: builder.query<
      DashboardMetricsResponse,
      { tab: string; timePeriod: string }
    >({
      query: ({ tab, timePeriod }) => ({
        url: `/${API.GET_DASHBOARD}/metrics`,
        method: "GET",
        params: { tab, timePeriod },
      }),
      providesTags: ["Dashboard"],
    }),
    getDashboardCharts: builder.query<
      DashboardChartsResponse,
      { tab: string; timePeriod: string }
    >({
      query: ({ tab, timePeriod }) => ({
        url: `/${API.GET_DASHBOARD}/charts`,
        method: "GET",
        params: { tab, timePeriod },
      }),
      providesTags: ["Dashboard"],
    }),
  }),
});

export const { useGetDashboardMetricsQuery, useGetDashboardChartsQuery } = dashboardApi;
